<template>
  <div class="contents oshirase-summary-container">
    <loading v-if="isLoading" :message="'読み込み中...'"></loading>
    <div class="oshirase-list" v-else>
      <template v-if="OshiraseList.length > 0" v-for="oshirase in OshiraseList" :key="oshirase.oshirase_id">
        <oshirase-item :oshirase="oshirase" v-on:destroy="destroy(oshirase)"></oshirase-item>
      </template>
      <p class="align-center" v-else>{{ Message.EMPTY_OSHIRASE }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { useInit } from '@/composable/oshirase/init';
import { defineComponent, onMounted } from 'vue'
import oshiraseItem from '@/components/oshirase/Item.vue'
import { useOshiraseList } from '@/composable/oshirase/list';
import Message from '@/const/Message';

export default defineComponent({
  setup() {
    const { OshiraseList } = useInit();
    const { destroy, isLoading, getOshiraseSummary } = useOshiraseList(OshiraseList);

    onMounted(async () => {
      await getOshiraseSummary();
    })
    return {
      OshiraseList,
      destroy,
      isLoading,
      Message
    }
  },
  components: {
    'oshirase-item': oshiraseItem
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/oshirase-list.scss';
</style>
